import LinkCardGrid from './LinkCardGrid';
import React from 'react';

const LinkCardGridWithProps = (props: any) => {
  return (
    <LinkCardGrid
      sectionTitle={props.sectionTitle}
      sectionDescription={props.sectionDescription}
      linkCardItems={props.linkCardItems}
      compactMode={props.compactMode}
      suffixText={props.suffixText}
    />
  );
};

export default LinkCardGridWithProps;
